import axios from "axios";
import {
  postTripData,
  getTripData,
  getDetailPageData,
  getImagesGalleryData,
  getVideosGalleryData,
} from "../features/customerViewSlice";

const axiosClient = axios.create();

// <-----------[DEV ENPOINT]----------->
axiosClient.defaults.baseURL = "https://tripdevapi.unravelapp.com";

// <-----------[PROD ENPOINT]----------->
// axiosClient.defaults.baseURL = "https://tripapi.unravelapp.com";

// axiosClient.defaults.baseURL = 'https://tripdevapi.unravelapp.com'
// if (process.env.NODE_ENV === 'production') {
//   axiosClient.defaults.baseURL = 'https://tripapi.unravelapp.com'
// }

var host = window.location.hostname;
if (host === "trip.unravelapp.com" || host === "trips.unravelapp.com") {
  axiosClient.defaults.baseURL = "https://tripapi.unravelapp.com";
}

axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

// Async api calls
export const getTripDataAsync = (URL) => async (dispatch) => {
  try {
    const response = await axiosClient.get(`/${URL}`);
    // console.log(response)
    dispatch(getTripData(response.data.data));
  } catch (error) {
    throw Error(error);
  }
};

export const postTripDataAsync = (URL, payload, header) => async (dispatch) => {
  try {
    const response = await axiosClient.post(`/${URL}`, payload, header);
    console.log(response);
    dispatch(postTripData(response.data.data));
  } catch (error) {
    throw Error(error);
  }
};

export const getDetailPageDataAsync = (URL, header) => async (dispatch) => {
  try {
    const response = await axiosClient.get(`/${URL}`, header);
    dispatch(getDetailPageData(response.data.data));
    console.log(response);
  } catch (error) {
    throw Error(error);
  }
};

export const getImagesGalleryDataAsync = (URL, header) => async (dispatch) => {
  try {
    const response = await axiosClient.get(`/${URL}`, header);
    dispatch(getImagesGalleryData(response.data.data));
    console.log(response);
  } catch (error) {
    throw Error(error);
  }
};

export const getVideosGalleryDataAsync = (URL, header) => async (dispatch) => {
  try {
    const response = await axiosClient.get(`/${URL}`, header);
    dispatch(getVideosGalleryData(response.data.data));
    console.log(response);
  } catch (error) {
    throw Error(error);
  }
};

// export const patchTripDataAsync = (URL, payload) => async (dispatch) =>{
//     try {
//         const response = await axiosClient.patch(`/${URL}`, payload);
//         console.log(response)
//         dispatch(patchTripData(response.data))
//     } catch (error) {
//       throw Error(error)
//     }
// }

// export const deleteTripDataAsync = (URL) => async (dispatch) =>{
//     try {
//         const response = await axiosClient.delete(`/${URL}`)
//         console.log(response)
//         dispatch(deleteTripData(response.data))
//     } catch (error) {
//       throw Error(error)
//     }
// }
